import React from 'react';
import { useCollectionItemQuery } from '@annunciate/query';
import { DisplayMode } from '@annunciate/core';
import { CarouselDisplay } from './CarouselDisplay';
export const Carousel = ({ index, collection, scrollMap, }) => {
    const { isFetchingNextPage, isFetchingPreviousPage, isPending, hasNextPage, data, fetchNextPage, } = useCollectionItemQuery({
        parentId: collection.id,
        displayMode: DisplayMode.CAROUSEL_SLIDES,
        shouldObserveUser: collection.isUserDependent,
    });
    const isLoadingPage = isFetchingNextPage || isFetchingPreviousPage;
    if (!isPending && data.length === 0) {
        return null;
    }
    return (React.createElement(CarouselDisplay, { index: index, collection: collection, isLoadingPage: isLoadingPage, isLoading: isPending, items: data, hasNextPage: hasNextPage, fetchNextPage: fetchNextPage, scrollMap: scrollMap }));
};
//# sourceMappingURL=Carousel.js.map